import React from 'react';
import {useTranslation} from 'react-i18next';

import {Language} from 'src/components';
import {isEnDomain} from 'src/constants';
import {parseISO} from 'src/utils';

import * as S from './style';

const SUPPORT_EMAIL_RU = 'support@edna.ru';
const SUPPORT_EMAIL_IO = 'support@edna.io';

const Footer = () => {
  const {t} = useTranslation();
  const supportEmail = isEnDomain() ? SUPPORT_EMAIL_IO : SUPPORT_EMAIL_RU;

  return (
    <S.Footer>
      <S.FooterContent>
        <S.Left>
          <S.CopyRight
            data-selector="Footer:copyRight"
            title={`${BUILDINFO.version}\n${parseISO(BUILDINFO.timestamp, 'dd MMMM yyyy')}`}
          >
            {`© 2005—${new Date().getFullYear()} edna`}
          </S.CopyRight>
          <S.Link href={`mailto:${supportEmail}`} data-selector="Footer:support">
            {t('Common:support')}
          </S.Link>
        </S.Left>
        <Language placementY="top" readOnly={isEnDomain()} />
      </S.FooterContent>
    </S.Footer>
  );
};

Footer.displayName = 'Footer';

export default Footer;
